import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import { useMessageApi } from "../../../provider/AntdNotification";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import { useQueryState } from "nuqs";
import ContactListing from "./contactList";
import EnquiryListing from "./enquiryList";

const EnquiryTabs: React.FC<{
  setBreadcrumb: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Contact";
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();


  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  

  const sections = ["Contact", "Looking For A Change?"];

  return (
    <div>
      <TabsContain
        sections={sections}
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
      />

      {activeTab === "Contact" && (
        <><ContactListing formType="CONTACT"/></>
      )}

      {activeTab === "Looking For A Change?" && (
        <><EnquiryListing formType="ENQUIRY"/></>
      )}
      
    </div>
  );
};

export default EnquiryTabs;
